import React, { Component } from 'react';

import { REST_API_URL } from "../../Utils/Global";

import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import Alerte from '../Entity/Alerte'

/**
* Class AlerteList
* AlerteList view component
**/
class AlerteList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = Alerte;

    // Filter list
    const filters = [{
      title: "Nom de l'alerte",
      type: "text",
      name: "libelle",
      rowIdx: 1
    },{
      title: "Date de début",
      type: "dateinterval",
      name: "premiereDate.dateDeclenchement",
      rowIdx: 1
    },{
      title: "Date de fin",
      type: "dateinterval",
      name: "derniereDate.dateDeclenchement",
      rowIdx: 1
    },{
      title: "Créée par",
      type: "combo",
      name: "libelleUtilisateur",
      optionValueKey: "displayName",
      optionLabelKey: "displayName",
      url: REST_API_URL + "/alertes/auteurs",
      rowIdx: 1
    }
    // ,{
    //   type: "map",
    //   layer: "alerte",
    //   name: "idAlerte",
    //   rowIdx: 1
    // }
  ];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes alertes</h2>
        <GridFilter title="Filtrer les alertes" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Alertes" ref={"gridAlerte"} path="alertes" objectPath="alertes" objectClass={objectClass} height="400px" hidden={false} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs.gridAlerte;
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs.gridAlerte;
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * applyDateIntervalFilter
  * Filters the grid
  **/
  applyDateIntervalFilter(fieldName, values) {
    const grid = this.refs.gridAlerte;
    grid.applyDateIntervalFilter(fieldName, values);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs.gridAlerte;
    grid.clearFilters();
  }

}
export default AlerteList;



// WEBPACK FOOTER //
// ./src/views/Search/AlerteList.js